import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ef10941"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Login", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Login", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Forget password?", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "No account yet?", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Register now", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import {ref, getCurrentInstance} from 'vue'
import {useRouter} from 'vue-router'
import store from "@/store/index";
import axios from "axios";
import {
  FormInst, FormItemInst, FormItemRule, FormRules,
  NCard, NForm, NInput, NFormItem, NButton, NSpace
} from 'naive-ui'
import {LoginModel, LoginDto} from '@/types/Login'
import {ValidateError} from "async-validator";
import jwt_decode from "jwt-decode";
import Brand from '@/components/Brand.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const parameters = ["email", "password"]
const router = useRouter()
const app = getCurrentInstance()
const message = app!.appContext.config.globalProperties.message
const model = ref<LoginModel>({
  email: null,
  password: null,
})

const form = ref<FormInst | null>(null)
const passwordFormItem = ref<FormItemInst | null>(null)
const rules: FormRules = {
  email: [
    {
      required: true,
      message: 'Email is required',
      trigger: ['change']
    },
    {
      validator(rule: FormItemRule, value: string) {
        return /\b[\w.\-+]+@[\w.-]+.\w{2,4}\b/.test(value)
      },
      message: 'Email is invalid',
      trigger: ['change']
    }
  ],
  password: [
    {
      required: true,
      message: "Password is required",
      trigger: ['change']
    }
  ]
}

function validateForm(errors: ValidateError[][] | undefined) {
  if (!errors) {
    axios.defaults.headers.common["Authorization"] = "";
    localStorage.removeItem("token");
    localStorage.removeItem("refresh");

    let payload = new LoginDto(model.value)
    axios.post('/api/auth/token/', payload)
        .then((response) => {
          model.value = {
            email: null,
            password: null
          }
          const token = response.data.access;
          const refresh = response.data.refresh;
          store.commit("setToken", token);
          store.commit("setRefresh", refresh);
          store.commit("setIdentity", token);

          axios.defaults.headers.common["Authorization"] = "Bearer " + token;

          message.success("Login is successful!", {showIcon: true, closable: true})
          if (store.state.isAdmin) {
            router.push("/artists-list")
          } else {
            router.push("/profil")
          }
        })
        .catch((error) => {
          if (error.response.status == 401) {
            message.error('Wrong email or password! Please try again', {showIcon: true, closable: true})
          } else {
            message.error("A problem is occurred when logging in", {showIcon: true, closable: true})
            console.error(error)
          }
        })
  }
}

function handleValidateButtonClick(e: MouseEvent) {
  e.preventDefault()
  form.value!.validate(validateForm).catch(error => {
    message.error('Form login is invalid', {
      showIcon: true, closable: true
    })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NCard), { size: "small" }, {
      header: _withCtx(() => [
        _createVNode(_unref(NSpace), {
          id: "form-title",
          vertical: "",
          align: "center",
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(Brand, { "is-center": true }),
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(NForm), {
          ref_key: "form",
          ref: form,
          model: model.value,
          rules: rules
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NFormItem), {
              id: "emailForm",
              path: "email",
              first: "",
              label: "Email"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  id: "email",
                  value: model.value.email,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((model.value.email) = $event)),
                  onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                  size: "large"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(NFormItem), {
              id: "passwordForm",
              path: "password",
              first: "",
              label: "Password"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  id: "password",
                  value: model.value.password,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((model.value.password) = $event)),
                  type: "password",
                  "show-password-on": "mousedown",
                  size: "large"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(NButton), {
              id: "submitBtn",
              type: "primary",
              "attr-type": "submit",
              onClick: handleValidateButtonClick,
              size: "large"
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_unref(NSpace), { style: {"margin-top":"0.5em"} }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              class: "router-link",
              to: "/forget-password"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(NSpace), {
          vertical: "",
          align: "center"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6,
            _createVNode(_component_router_link, {
              class: "router-link",
              to: "/register"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})